import { Box } from "@mui/material";
import { useNavigate } from "react-router-dom";
import { emailRegister, googleSignIn } from "../firebase";
import RegisterCard from "../components/register/RegisterCard";
import { useSnack } from "../contexts/AlertContext";

const Register = () => {
  const setSnack = useSnack();
  const navigate = useNavigate;

  const handleRegister = async (data) => {
    const { username, email, password } = data;
    try {
      await emailRegister(username, email, password);
      navigate("/record");
      setSnack({
        open: true,
        type: "success",
        message: "New Account successfully created"
      });
    } catch (e) {
      switch (e.code) {
        case "auth/email-already-in-use":
          setSnack({
            open: true,
            type: "error",
            message: "Registered email already used. Please try another email."
          });
          break;
        default:
          setSnack({
            open: true,
            type: "error",
            message:
              "There was an error regsitering your email. Please try again."
          });
      }
    }
  };

  const handleGoogleSignIn = () => {
    try {
      googleSignIn();
    } catch (e) {
      setSnack({
        open: true,
        type: "error",
        message:
          e?.code || "An unknown error occured. Please try to login again"
      });
    }
  };

  return (
    <Box sx={{ marginX: "auto", marginTop: "20%", maxWidth: 600 }}>
      <RegisterCard
        onRegister={handleRegister}
        onGoogleSignIn={handleGoogleSignIn}
      />
    </Box>
  );
};

export default Register;
